export default {
  INSIDE_MARGIN: {
    value: 'INSIDE_MARGIN',
    label: 'Valores dentro da margem',
  },
  OUT_OF_MARGIN: {
    value: 'OUT_OF_MARGIN',
    label: 'Valores fora da margem',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-generation/enums/EnumMarginStatus.js